import { render, staticRenderFns } from "./DocSmartAnts.vue?vue&type=template&id=c2082388&scoped=true"
import script from "./DocSmartAnts.vue?vue&type=script&lang=js"
export * from "./DocSmartAnts.vue?vue&type=script&lang=js"
import style0 from "./DocSmartAnts.vue?vue&type=style&index=0&id=c2082388&prod&lang=css"
import style1 from "./DocSmartAnts.vue?vue&type=style&index=1&id=c2082388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2082388",
  null
  
)

export default component.exports